// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
export default {
   "AD": {
     "national": "(?:1|6\\d)\\d{7}|[135-9]\\d{5}"
   },
   "AE": {
     "national": "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}"
   },
   "AF": {
     "national": "[2-7]\\d{8}"
   },
   "AL": {
     "national": "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}"
   },
   "AM": {
     "national": "(?:[1-489]\\d|55|60|77)\\d{6}"
   },
   "AO": {
     "national": "[29]\\d{8}"
   },
   "AR": {
     "national": "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}"
   },
   "AT": {
     "national": "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}"
   },
   "AU": {
     "national": "1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}"
   },
   "AW": {
     "national": "(?:[25-79]\\d\\d|800)\\d{4}"
   },
   "AZ": {
     "national": "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}"
   },
   "BA": {
     "national": "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}"
   },
   "BD": {
     "national": "1\\d{9}|2\\d{7,8}|88\\d{4,6}|(?:8[0-79]|9\\d)\\d{4,8}|(?:[346]\\d|[57])\\d{5,8}"
   },
   "BE": {
     "national": "4\\d{8}|[1-9]\\d{7}"
   },
   "BF": {
     "national": "[025-7]\\d{7}"
   },
   "BG": {
     "national": "[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}"
   },
   "BH": {
     "national": "[136-9]\\d{7}"
   },
   "BI": {
     "national": "(?:[267]\\d|31)\\d{6}"
   },
   "BJ": {
     "national": "[25689]\\d{7}"
   },
   "BN": {
     "national": "[2-578]\\d{6}"
   },
   "BO": {
     "national": "(?:[2-467]\\d\\d|8001)\\d{5}"
   },
   "BR": {
     "national": "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}"
   },
   "BT": {
     "national": "[17]\\d{7}|[2-8]\\d{6}"
   },
   "BW": {
     "national": "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}"
   },
   "BY": {
     "national": "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}"
   },
   "BZ": {
     "national": "(?:0800\\d|[2-8])\\d{6}"
   },
   "CA": {
     "national": "(?:[2-8]\\d|90)\\d{8}"
   },
   "CD": {
     "national": "[189]\\d{8}|[1-68]\\d{6}"
   },
   "CF": {
     "national": "(?:[27]\\d{3}|8776)\\d{4}"
   },
   "CG": {
     "national": "222\\d{6}|(?:0\\d|80)\\d{7}"
   },
   "CH": {
     "national": "8\\d{11}|[2-9]\\d{8}"
   },
   "CI": {
     "national": "[02]\\d{9}"
   },
   "CK": {
     "national": "[2-578]\\d{4}"
   },
   "CL": {
     "national": "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}"
   },
   "CM": {
     "national": "[26]\\d{8}|88\\d{6,7}"
   },
   "CN": {
     "national": "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}"
   },
   "CO": {
     "national": "(?:1\\d|3)\\d{9}|[124-8]\\d{7}"
   },
   "CR": {
     "national": "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}"
   },
   "CU": {
     "national": "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}"
   },
   "CV": {
     "national": "(?:[2-59]\\d\\d|800)\\d{4}"
   },
   "CW": {
     "national": "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}"
   },
   "CY": {
     "national": "(?:[279]\\d|[58]0)\\d{6}"
   },
   "CZ": {
     "national": "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}"
   },
   "DE": {
     "national": "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:[12]\\d|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|31|[46][1-8])\\d{1,9}"
   },
   "DJ": {
     "national": "(?:2\\d|77)\\d{6}"
   },
   "DK": {
     "national": "[2-9]\\d{7}"
   },
   "DZ": {
     "national": "(?:[1-4]|[5-79]\\d|80)\\d{7}"
   },
   "EC": {
     "national": "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}"
   },
   "EE": {
     "national": "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}"
   },
   "EG": {
     "national": "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}"
   },
   "ER": {
     "national": "[178]\\d{6}"
   },
   "ES": {
     "national": "[5-9]\\d{8}"
   },
   "ET": {
     "national": "(?:11|[2-59]\\d)\\d{7}"
   },
   "FI": {
     "national": "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}"
   },
   "FJ": {
     "national": "45\\d{5}|(?:0800\\d|[235-9])\\d{6}"
   },
   "FM": {
     "national": "(?:[39]\\d\\d|820)\\d{4}"
   },
   "FO": {
     "national": "[2-9]\\d{5}"
   },
   "FR": {
     "national": "[1-9]\\d{8}"
   },
   "GA": {
     "national": "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}"
   },
   "GB": {
     "national": "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}"
   },
   "GE": {
     "national": "(?:[3-57]\\d\\d|800)\\d{6}"
   },
   "GF": {
     "national": "(?:[56]94|80\\d|976)\\d{6}"
   },
   "GH": {
     "national": "(?:[235]\\d{3}|800)\\d{5}"
   },
   "GI": {
     "national": "(?:[25]\\d\\d|606)\\d{5}"
   },
   "GL": {
     "national": "(?:19|[2-689]\\d)\\d{4}"
   },
   "GM": {
     "national": "[2-9]\\d{6}"
   },
   "GN": {
     "national": "722\\d{6}|(?:3|6\\d)\\d{7}"
   },
   "GP": {
     "national": "(?:590|(?:69|80)\\d|976)\\d{6}"
   },
   "GQ": {
     "national": "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}"
   },
   "GR": {
     "national": "5005000\\d{3}|8\\d{9,10}|(?:[269]\\d|70)\\d{8}"
   },
   "GT": {
     "national": "(?:1\\d{3}|[2-7])\\d{7}"
   },
   "GW": {
     "national": "[49]\\d{8}|4\\d{6}"
   },
   "GY": {
     "national": "(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}"
   },
   "HK": {
     "national": "8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}"
   },
   "HN": {
     "national": "8\\d{10}|[237-9]\\d{7}"
   },
   "HR": {
     "national": "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}"
   },
   "HT": {
     "national": "[2-489]\\d{7}"
   },
   "HU": {
     "national": "[235-7]\\d{8}|[1-9]\\d{7}"
   },
   "ID": {
     "national": "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}"
   },
   "IE": {
     "national": "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}"
   },
   "IL": {
     "national": "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}"
   },
   "IN": {
     "national": "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}"
   },
   "IO": {
     "national": "3\\d{6}"
   },
   "IQ": {
     "national": "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}"
   },
   "IR": {
     "national": "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}"
   },
   "IS": {
     "national": "(?:38\\d|[4-9])\\d{6}"
   },
   "IT": {
     "national": "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}"
   },
   "JO": {
     "national": "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}"
   },
   "JP": {
     "national": "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}"
   },
   "KE": {
     "national": "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}"
   },
   "KG": {
     "national": "8\\d{9}|(?:[235-8]\\d|99)\\d{7}"
   },
   "KH": {
     "national": "1\\d{9}|[1-9]\\d{7,8}"
   },
   "KM": {
     "national": "[3478]\\d{6}"
   },
   "KP": {
     "national": "85\\d{6}|(?:19\\d|[2-7])\\d{7}"
   },
   "KR": {
     "national": "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}"
   },
   "KW": {
     "national": "(?:18|[2569]\\d\\d)\\d{5}"
   },
   "LA": {
     "national": "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}"
   },
   "LB": {
     "national": "[27-9]\\d{7}|[13-9]\\d{6}"
   },
   "LI": {
     "national": "90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}"
   },
   "LK": {
     "national": "[1-9]\\d{8}"
   },
   "LR": {
     "national": "(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}"
   },
   "LS": {
     "national": "(?:[256]\\d\\d|800)\\d{5}"
   },
   "LT": {
     "national": "(?:[3469]\\d|52|[78]0)\\d{6}"
   },
   "LU": {
     "national": "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}"
   },
   "LV": {
     "national": "(?:[268]\\d|90)\\d{6}"
   },
   "LY": {
     "national": "[2-9]\\d{8}"
   },
   "MA": {
     "national": "[5-8]\\d{8}"
   },
   "MC": {
     "national": "(?:[3489]|6\\d)\\d{7}"
   },
   "MD": {
     "national": "(?:[235-7]\\d|[89]0)\\d{6}"
   },
   "ME": {
     "national": "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}"
   },
   "MG": {
     "national": "[23]\\d{8}"
   },
   "MH": {
     "national": "329\\d{4}|(?:[256]\\d|45)\\d{5}"
   },
   "MK": {
     "national": "[2-578]\\d{7}"
   },
   "ML": {
     "national": "[24-9]\\d{7}"
   },
   "MM": {
     "national": "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}"
   },
   "MN": {
     "national": "[12]\\d{7,9}|[57-9]\\d{7}"
   },
   "MO": {
     "national": "(?:28|[68]\\d)\\d{6}"
   },
   "MQ": {
     "national": "(?:69|80)\\d{7}|(?:59|97)6\\d{6}"
   },
   "MR": {
     "national": "(?:[2-4]\\d\\d|800)\\d{5}"
   },
   "MT": {
     "national": "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}"
   },
   "MU": {
     "national": "(?:[2-468]|5\\d)\\d{6}"
   },
   "MV": {
     "national": "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}"
   },
   "MW": {
     "national": "(?:[19]\\d|[23]1|77|88)\\d{7}|1\\d{6}"
   },
   "MX": {
     "national": "(?:1(?:[01467]\\d|[2359][1-9]|8[1-79])|[2-9]\\d)\\d{8}"
   },
   "MY": {
     "national": "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}"
   },
   "MZ": {
     "national": "(?:2|8\\d)\\d{7}"
   },
   "NA": {
     "national": "[68]\\d{7,8}"
   },
   "NC": {
     "national": "[2-57-9]\\d{5}"
   },
   "NE": {
     "national": "[027-9]\\d{7}"
   },
   "NF": {
     "national": "[13]\\d{5}"
   },
   "NG": {
     "national": "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}"
   },
   "NI": {
     "national": "(?:1800|[25-8]\\d{3})\\d{4}"
   },
   "NL": {
     "national": "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}"
   },
   "NO": {
     "national": "(?:0|[2-9]\\d{3})\\d{4}"
   },
   "NP": {
     "national": "(?:1\\d|9)\\d{9}|[1-9]\\d{7}"
   },
   "NR": {
     "national": "(?:444|(?:55|8\\d)\\d|666)\\d{4}"
   },
   "NU": {
     "national": "(?:[47]|888\\d)\\d{3}"
   },
   "NZ": {
     "national": "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}"
   },
   "OM": {
     "national": "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}"
   },
   "PA": {
     "national": "8\\d{9}|[68]\\d{7}|[1-57-9]\\d{6}"
   },
   "PE": {
     "national": "(?:[14-8]|9\\d)\\d{7}"
   },
   "PF": {
     "national": "4\\d{5}(?:\\d{2})?|8\\d{7,8}"
   },
   "PG": {
     "national": "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}"
   },
   "PH": {
     "national": "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}"
   },
   "PK": {
     "national": "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}"
   },
   "PL": {
     "national": "6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?"
   },
   "PM": {
     "national": "(?:[45]|80\\d\\d)\\d{5}"
   },
   "PR": {
     "national": "(?:[589]\\d\\d|787)\\d{7}"
   },
   "PS": {
     "national": "[2489]2\\d{6}|(?:1\\d|5)\\d{8}"
   },
   "PT": {
     "national": "(?:[26-9]\\d|30)\\d{7}"
   },
   "PW": {
     "national": "(?:[24-8]\\d\\d|345|900)\\d{4}"
   },
   "PY": {
     "national": "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}"
   },
   "QA": {
     "national": "[2-7]\\d{7}|(?:2\\d\\d|800)\\d{4}"
   },
   "RE": {
     "national": "9769\\d{5}|(?:26|[68]\\d)\\d{7}"
   },
   "RO": {
     "national": "(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}"
   },
   "RS": {
     "national": "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}"
   },
   "RU": {
     "national": "[347-9]\\d{9}"
   },
   "RW": {
     "national": "(?:06|[27]\\d\\d|[89]00)\\d{6}"
   },
   "SA": {
     "national": "92\\d{7}|(?:[15]|8\\d)\\d{8}"
   },
   "SB": {
     "national": "(?:[1-6]|[7-9]\\d\\d)\\d{4}"
   },
   "SC": {
     "national": "8000\\d{3}|(?:[249]\\d|64)\\d{5}"
   },
   "SD": {
     "national": "[19]\\d{8}"
   },
   "SE": {
     "national": "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}"
   },
   "SG": {
     "national": "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}"
   },
   "SI": {
     "national": "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}"
   },
   "SK": {
     "national": "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}"
   },
   "SL": {
     "national": "(?:[237-9]\\d|66)\\d{6}"
   },
   "SM": {
     "national": "(?:0549|[5-7]\\d)\\d{6}"
   },
   "SN": {
     "national": "(?:[378]\\d{4}|93330)\\d{4}"
   },
   "SO": {
     "national": "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}"
   },
   "SR": {
     "national": "(?:[2-5]|68|[78]\\d)\\d{5}"
   },
   "SS": {
     "national": "[19]\\d{8}"
   },
   "ST": {
     "national": "(?:22|9\\d)\\d{5}"
   },
   "SV": {
     "national": "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?"
   },
   "SY": {
     "national": "[1-39]\\d{8}|[1-5]\\d{7}"
   },
   "SZ": {
     "national": "0800\\d{4}|(?:[237]\\d|900)\\d{6}"
   },
   "TD": {
     "national": "(?:22|[69]\\d|77)\\d{6}"
   },
   "TG": {
     "national": "[279]\\d{7}"
   },
   "TH": {
     "national": "1\\d{9}|[1689]\\d{8}|[1-57]\\d{7}"
   },
   "TJ": {
     "national": "(?:00|11|[2-57-9]\\d)\\d{7}"
   },
   "TL": {
     "national": "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}"
   },
   "TM": {
     "national": "[1-6]\\d{7}"
   },
   "TN": {
     "national": "[2-57-9]\\d{7}"
   },
   "TO": {
     "national": "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}"
   },
   "TR": {
     "national": "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}"
   },
   "TV": {
     "national": "(?:2|7\\d\\d|90)\\d{4}"
   },
   "TW": {
     "national": "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}"
   },
   "TZ": {
     "national": "(?:[26-8]\\d|41|90)\\d{7}"
   },
   "UA": {
     "national": "[89]\\d{9}|[3-9]\\d{8}"
   },
   "UG": {
     "national": "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}"
   },
   "US": {
     "national": "[2-9]\\d{9}"
   },
   "UY": {
     "national": "4\\d{9}|[249]\\d{7}|(?:[49]\\d|80)\\d{5}"
   },
   "UZ": {
     "national": "(?:33|55|[679]\\d|88)\\d{7}"
   },
   "VE": {
     "national": "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}"
   },
   "VN": {
     "national": "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}"
   },
   "VU": {
     "national": "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}"
   },
   "WF": {
     "national": "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?"
   },
   "WS": {
     "national": "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}"
   },
   "XK": {
     "national": "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}"
   },
   "YE": {
     "national": "(?:1|7\\d)\\d{7}|[1-7]\\d{6}"
   },
   "ZA": {
     "national": "[1-79]\\d{8}|8\\d{4,9}"
   },
   "ZM": {
     "national": "(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}"
   },
   "ZW": {
     "national": "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}"
   }
 }